import React from 'react';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Badge } from '../../components/ui/badge';

export const EFFECTIF_OPTIONS = [
  '0 salarié',
  '1-5 salariés',
  '6-10 salariés',
  '11-20 salariés',
  '21-50 salariés',
  'Plus de 50 salariés',
];

/**
 * Mappe une valeur d'effectif venant de la fiche membre (qui peut être un
 * nombre brut ex: 4, ou une string ex: "4", "1-5 salariés", "5") vers l'une
 * des options EFFECTIF_OPTIONS exactes.
 * Retourne null si la valeur est vide / non interprétable.
 */
export function mapEffectifToOption(raw) {
  if (raw === null || raw === undefined || raw === '') return null;
  // Déjà une option valide ?
  if (typeof raw === 'string' && EFFECTIF_OPTIONS.includes(raw)) return raw;
  // Tente d'extraire un entier (gère "4", "4 salariés", "  4", 4, etc.)
  const n = parseInt(String(raw).match(/-?\d+/)?.[0] ?? '', 10);
  if (!Number.isFinite(n)) return null;
  if (n <= 0) return '0 salarié';
  if (n <= 5) return '1-5 salariés';
  if (n <= 10) return '6-10 salariés';
  if (n <= 20) return '11-20 salariés';
  if (n <= 50) return '21-50 salariés';
  return 'Plus de 50 salariés';
}

export function VentilationGroup({ title, items, values, onChange, testidPrefix }) {
  const total = Object.values(values).reduce((s, v) => s + (Number(v) || 0), 0);
  const isValid = Math.abs(total - 100) <= 1 || total === 0;

  return (
    <div className="space-y-2" data-testid={`${testidPrefix}-group`}>
      <div className="flex items-center justify-between">
        <Label className="text-xs font-semibold text-slate-700">{title}</Label>
        <Badge
          className={`text-[10px] font-bold border-0 shadow-sm ${
            !isValid
              ? 'bg-rose-600 text-white'
              : total === 100
              ? 'bg-emerald-600 text-white'
              : 'bg-slate-900 text-white'
          }`}
          data-testid={`${testidPrefix}-total`}
        >
          {total.toFixed(0)}%
        </Badge>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
        {items.map((it) => (
          <div key={it.key} className="space-y-1">
            <Label className="text-[11px] text-slate-600">{it.label}</Label>
            <div className="relative">
              <Input
                type="number"
                min="0"
                max="100"
                step="1"
                value={values[it.key] ?? ''}
                onChange={(e) => onChange(it.key, e.target.value)}
                className="h-8 pr-7 text-sm"
                data-testid={`${testidPrefix}-${it.key}`}
              />
              <span className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 text-xs">%</span>
            </div>
          </div>
        ))}
      </div>
      {!isValid && (
        <p className="text-xs text-red-600">La somme doit faire 100% (actuellement {total.toFixed(0)}%).</p>
      )}
    </div>
  );
}
